export default __webpack_public_path__ + "static/media/638.fae95e51.png";